import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Signup } from './pages/Auth/Signup';
import { Login } from './pages/Auth/login';
import ChangePassword from './pages/Auth/changepassword';
import DashboardLayout from './pages/Dashboard/DashboardLayout';
import DashboardHome from './pages/Dashboard/DashboardHome';
import Country from './pages/Country/Country';
import Language from './pages/Language/Language';
import Source from './pages/Source/Source';
import Translation from './pages/Translation/Translation';
import Product from './pages/Product/Product';

import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import { AuthProvider } from './Context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Default route */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Auth routes */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          <Route 
            path="/signup" 
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            } 
          />

          {/* Admin Routes */}
          <Route element={<PrivateRoute allowedRoles={['admin']} />}>
            <Route path="/admin/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="country" element={<Country />} />
              <Route path="language" element={<Language />} />
              <Route path="source" element={<Source />} />
              <Route path="translation" element={<Translation />} />
              <Route path="product" element={<Product />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Route>

          {/* Client Routes */}
          <Route element={<PrivateRoute allowedRoles={['client']} />}>
            <Route path="/client/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="country" element={<Country />} />
              <Route path="language" element={<Language />} />
              <Route path="source" element={<Source />} />
              <Route path="translation" element={<Translation />} />
              <Route path="product" element={<Product />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
